export const initFooter = () => {
  const footer = document.querySelector('.footer-old');

  if (!footer) {
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    const intercom = document.querySelector('.intercom-launcher');

    if (intercom) {
      obs.disconnect();

      const io = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            intercom.classList.add('floated-up');
          } else {
            intercom.classList.remove('floated-up');
          }
        },
        { threshold: 0.1 }
      );

      io.observe(footer);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};
